import $apiJSON from '../http/apiJSON';

export const ping = async () => {
    // Add timestamp to prevent caching
    return $apiJSON.get(`speedtest/ping/?t=${Date.now()}`);
};

export const getClientInfo = async () => {
    return $apiJSON.get(`speedtest/info/`);
};

export const download = async (size, signal, onProgress) => {
    return $apiJSON.get(`speedtest/download/?size=${size}&nocache=${Date.now()}`, {
        responseType: 'blob',
        signal: signal,
        onDownloadProgress: onProgress
    });
};

export const upload = async (data, signal, onProgress) => {
    return $apiJSON.post(`speedtest/upload/?nocache=${Date.now()}`, data, {
        headers: {
            'Content-Type': 'application/octet-stream' 
        },
        signal: signal,
        onUploadProgress: onProgress
    });
};

class InternetSpeedService {
    static async checkPing() {
        return await ping();
    }

    static async getClientInfo() {
        return await getClientInfo();
    }

    static async runDownload(size, signal, onProgress) {
        return await download(size, signal, onProgress);
    }

    static async runUpload(data, signal, onProgress) {
        return await upload(data, signal, onProgress);
    }
}

export default InternetSpeedService;
